<template>
	<div>
		<!-- <div id="shippingDocument"></div>
		<div id="invoiceDocument"></div> -->
		<b-container fluid>
			<b-breadcrumb :items="breadcrumb" style="margin-top: 15px;"></b-breadcrumb>
			<b-row style="margin: 10px 0px 10px 0px; padding: 0px;">
				<b-col cols="3" style="padding-right: 0px; padding-left: 0px;" >
					<label><strong>Ciclo de facturación</strong></label> &nbsp;
					<date-pick v-model="paymentDate" :format="dateFormat" :input-attributes="{ class: 'form-control' }" :weekdays="$lang.weekDays" :months="$lang.months" :is-date-disabled="datesDisabled"></date-pick>
				</b-col>
				<b-col cols="9" style="padding-right: 0px; padding-left: 0px;" >
					<b-input-group >
						<b-input :placeholder="$lang.common.search" v-model="keyword" />
						<b-input-group-append>
							<b-button variant="outline-primary" @click="searchInvoiceOrders">{{ $lang.common.search }}</b-button>
						</b-input-group-append>
					</b-input-group>
				</b-col>
			</b-row>
			<b-table striped hover outlined :items="$store.getters.invoices" :fields="fields" @row-clicked="editInvoice" style="cursor:pointer">
				<template v-slot:head(shippingDocument)="data">
					<div class="text-center">{{ data.label }}</div>
				</template>
				<template v-slot:head(invoiceDocument)="data">
					<div class="text-center">{{ data.label }}</div>
				</template>
				<template v-slot:cell(index)="data">
					{{ data.index + 1 }}
				</template>
				<template v-slot:cell(purchaseOrderNumber)="data">
					{{ addPad(data.item.purchaseOrderNumber) }}
				</template>
				<template v-slot:cell(number)="data">
					{{ addPad(data.item.number) }}
				</template>
				<!-- <template v-slot:cell(status)="data">
					{{ $lang.finnance.purchaseOrders.statuses[data.item.status.value] }}
				</template> -->
				<template v-slot:cell(costCenterName)="data">
					{{ data.item.costCenterName }}
				</template>
				<template v-slot:cell(providerName)="data">
					{{ data.item.providerName }}
				</template>
				<template v-slot:cell(invoiceDate)="data">
					{{ data.item.invoiceDate || 'N/A'}}
				</template>
				<template v-slot:cell(paymentDate)="data">
					{{ data.item.paymentDate || 'N/A'}}
				</template>
				<template v-slot:cell(shippingDocument)="data">
					<b-row align-h="center">
						<b-button variant="outline-info" @click="downloadDocument(data.item.shippingDocument)"><font-awesome-icon icon="cloud-download-alt" /></b-button>
					</b-row>
				</template>
				<template v-slot:cell(invoiceDocument)="data">
					<b-row align-h="center">
						<b-button variant="outline-info" @click="downloadDocument(data.item.invoiceDocument)"><font-awesome-icon icon="cloud-download-alt" /></b-button>
					</b-row>
				</template>
			</b-table>
			<b-button variant="primary" class="title" block value="Save" v-on:click="loadMore" v-if="$store.state.invoices.invoicesPagination.showLoadMore == true">{{$lang.buttons.loadMore}}</b-button>
			<!-- <b-button variant="primary" class="title" block value="Save" v-on:click="loadMore" v-if="$store.state.purchaseOrders.purchaseOrdersPagination.showLoadMore == true">{{$lang.buttons.loadMore}}</b-button> -->
		</b-container>
	</div>
</template>

<script>
import moment from 'moment'
import DatePick from 'vue-date-pick'
import { dateFormat } from '../../../utils.js'

export default {
	data() {
		return {
			fields: [
				{key: 'index', label: '#'},
				{key: 'purchaseOrderNumber', label: 'Orden de compra'},
				{key: 'number', label: 'Número de factura'},
				{key: 'costCenterName', label: 'Centro de costo'},
				{key: 'providerName', label: 'Proveedor'},
				{key: 'invoiceDate', label: 'Fecha de facturación'},
				{key: 'paymentDate', label: 'Fecha de pago'},
				{key: 'shippingDocument', label: 'Orden de despacho'},
				{key: 'invoiceDocument', label: 'Factura'}
			],
			keyword: '',
			breadcrumb: [{'text': this.$lang.modules.finnance,'href': '/'},{'text': this.$lang.finnance.invoices.title,'href': '#'}],
			autoRefresh: '',
			dateFormat: dateFormat,
			paymentDate: moment().format(dateFormat)
		}
	},
	ready: () => {
		this.paymentDate = this.getNextPaymentDate()
	},
	components: { DatePick },
	methods: {
		editPurchaseOrder(purchaseOrder) {
            console.log(purchaseOrder)
			// this.$router.push({ name: 'PurchaseOrdersEdit', params: { purchaseOrderId: purchaseOrder.objectID } })
		},
		addPad(str) {
			if (str == undefined) {
				return 'TBD'
			}
			return str.toString().padStart(4,'0')
		},
		loadInvoices() {

		},
		loadMore() {

		},
		editInvoice() {

		},
		searchInvoiceOrders() {
			console.log(this.keyword)
			this.$store.commit('setInvoiceFilters', {keyword: this.keyword, paymentDate: this.paymentDate})
			this.$store.dispatch('fetchInvoices')
		},
		downloadDocument(doc) {
			let xhr = new XMLHttpRequest();
			xhr.responseType = 'blob';
			xhr.onload = function() {
				const blob = xhr.response;
				const link = document.createElement('a');
				link.href = URL.createObjectURL(blob);
				link.download = doc.name;
				link.click();
				URL.revokeObjectURL(link.href);
			};
			xhr.open('GET', doc.downloadURL);
			xhr.send();
		},
		datesDisabled(date) {
			date = moment(date).format('D')
            return (date !== '25' && date !== '10');
		},
		getNextPaymentDate() {
			// let date = parseInt(moment().format('D'))
			let date = 26
			let nextPaymentDate = moment()
			console.log(date)
			if (date <= 10) {
				nextPaymentDate.set('date', 10)
			}
			if (date > 10 && date <= 25) {
				nextPaymentDate.set('date', 25)
			}

			if (date > 25) {
				nextPaymentDate.set('date', 10)
				nextPaymentDate.set('month', parseInt(moment().format('M')))
			}
			this.paymentDate = nextPaymentDate.format(this.dateFormat)
		}
	},
	created() {
		// this.$Progress.start()
		// this.$store.commit('setDefaultInvoicesPagination')
		// this.$store.commit('setInvoices', [])
		// this.$store.dispatch('fetchInvoices')
		// this.$Progress.finish()
	},
	mounted() {
		this.getNextPaymentDate()
	}
}
</script>
<style>


</style>